# GraphQL mutation to enable/disable Google email sync
#import "../fragments/user-email-fragment.graphql"

mutation setGoogleMailSyncIsEnabled(
    $isEnabled: Boolean!
    $fromDaysAgo: Int
    $createContacts: Boolean
) {
    setGoogleMailSyncIsEnabled(
        input: {
            mailSync: {
                isEnabled: $isEnabled
                initialSyncStartFromDaysAgo: $fromDaysAgo
                initialSyncCreateContacts: $createContacts
            }
        }
    ) {
        authUrl
        emailAddresses {
            ...UserEmail
        }
    }
}
